// extracted by mini-css-extract-plugin
export default {"root":"Switch_root__BVgh1","input":"Switch_input__yF8l8","slider":"Switch_slider__44MEp","sliderSmall":"Switch_sliderSmall__QN-WC","sliderLarge":"Switch_sliderLarge__gJ45Y"};